import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { Image } from '../../../atoms'

interface IHouseSearchGatewayProps {
  onMapClick: () => void
  isDisabled?: boolean
}

export const HouseSearchMapGateway = ({
  isDisabled,
  onMapClick,
}: IHouseSearchGatewayProps) => {
  return (
    <div
      className={clsx(s.container, { [s.isDisabled]: isDisabled })}
      onClick={onMapClick}
    >
      <div className={s.mapImage}>
        <Image src='/images/map/map.png' alt='map' type='cover' />
      </div>
      <div className={s.button}>
        <p>
          <FormattedMessage
            id='ui.HouseSearchMapGateway.displayMap'
            defaultMessage='Afficher sur la carte'
          />
        </p>
      </div>
    </div>
  )
}
